import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "Intake",
  class: "dashboard-card d-flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Intake (Past 30 Days)")
], -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Loading your intake count", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "mt-5 text-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" There was a problem while fetching your intake count. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please try again. ")
], -1 /* HOISTED */)
const _hoisted_10 = {
  key: 2,
  class: "no-data"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "mb-3" }, " Good Job! There were no intake count. ", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "h-100 overflow-auto position-relative"
}
const _hoisted_14 = { id: "dashboard-table" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Service"),
  /*#__PURE__*/_createElementVNode("th", null, "Inquiry"),
  /*#__PURE__*/_createElementVNode("th", null, "Referral")
], -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 last-div table-background position-absolute" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardTemplate = _resolveComponent("CardTemplate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardTemplate, null, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        (_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ERROR "),
        (_ctx.hasError && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getIntakeCount()))
              }, "Try Again")
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" NO DATA "),
        (_ctx.intakeCount.length === 0 && !_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createElementBlock("section", _hoisted_10, _hoisted_12))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" DATA "),
        (_ctx.intakeCount.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("table", _hoisted_14, [
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intakeCount, (intake) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: intake.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.ApplicationNamesEnum.getDescriptionUsingValue(intake.application)), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(intake.inquiryCount), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(intake.referralCount), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _hoisted_16
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}